module.exports = __webpack_public_path__ + "static/cdn_activateConfig_img5_img.f2acd31b.png";